module.exports = __webpack_public_path__ + "img/banner4.e590e99e.jpg";